var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_724_3328",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.1765,
    height: 21.1765,
    transform: "matrix(0.615662 -0.788011 0.78396 0.620812 0.117676 16.7656)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_724_3328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1594 18.6341L15.9865 21.4153C15.235 22.3771 14.2572 22.93 13.0531 23.0738C11.8491 23.2177 10.7686 22.9107 9.81167 22.1529C8.85478 21.3952 8.30394 20.4103 8.15916 19.1983C8.01437 17.9863 8.31771 16.8994 9.06918 15.9375L11.2421 13.1563L12.6256 14.2519L10.4526 17.0331C9.99995 17.6125 9.81691 18.2648 9.90354 18.9899C9.99016 19.715 10.3217 20.3059 10.8981 20.7623C11.4746 21.2188 12.123 21.404 12.8434 21.318C13.5638 21.2319 14.1503 20.8992 14.603 20.3197L16.7759 17.5385L18.1594 18.6341ZM13.7628 18.5289L12.3793 17.4333L16.7252 11.8709L18.1086 12.9665L13.7628 18.5289ZM19.2459 17.2435L17.8624 16.1479L20.0353 13.3667C20.488 12.7873 20.671 12.135 20.5844 11.4099C20.4978 10.6848 20.1663 10.094 19.5898 9.63747C19.0134 9.18099 18.365 8.99578 17.6446 9.08184C16.9242 9.1679 16.3376 9.50064 15.8849 10.0801L13.712 12.8613L12.3286 11.7657L14.5015 8.98451C15.253 8.02267 16.2307 7.46983 17.4348 7.32599C18.6389 7.18215 19.7194 7.48911 20.6763 8.24686C21.6332 9.00462 22.184 9.9895 22.3288 11.2015C22.4736 12.4135 22.1702 13.5004 21.4188 14.4623L19.2459 17.2435Z",
    fill: "#1865C1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcona);
export default __webpack_public_path__ + "static/media/Link_icona.e7d2ae2d071d53bb328f310a69e87fe7.svg";
export { ForwardRef as ReactComponent };